import HeaderOne from "../components/HeaderOne";
import BannerOne from "../components/BannerOne";
import PopularOne from "../components/PopularOne";
import ArrivalOne from "../components/ArrivalOne";
import PerformanceAuthor from "../components/PerformanceAuthor";
import BecomeSellerOne from "../components/BecomeSellerOne";
import FooterOne from "../components/FooterOne";

const HomePage = () => {
  return (
    <section className="change-gradient">
      <HeaderOne />

      <BannerOne />

      <PopularOne />

      <ArrivalOne />

      {/* <FeaturedAuthor /> */}

      <PerformanceAuthor />

      <BecomeSellerOne />

      <FooterOne />
    </section>
  );
};

export default HomePage;
